import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../../services/locale/locale.service';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'localDate',
})
export class LocalDatePipe implements PipeTransform {
    public constructor(private readonly localeService: LocaleService) {}

    public transform(value: string | number | Date, format = 'shortDate'): unknown {
        if (!value) {
            return '';
        }
        return formatDate(value, format, this.localeService.locale);
    }
}
